module.exports = __webpack_public_path__ + "img/portfolio-07.0fab1b5c.jpg";